import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import BannerCardComponent from "../BannerCardComponent/BannerCardComponent";
import {
  IBannerSortProps,
  ISortableContainerProps,
} from "./BannerSortComponent.interface";

import "./BannerSortComponent.scss";

export const onSortEnd = (indexes: any, props: IBannerSortProps) => {
  const { banners, handleSortEnd } = props;
  let sortedBannerArray = arrayMove(
    banners,
    indexes.oldIndex,
    indexes.newIndex
  );
  handleSortEnd(sortedBannerArray);
};

const BannerSortComponent: React.FC<IBannerSortProps> = (
  props: IBannerSortProps
) => {
  const { banners } = props;
  const SortableItem = SortableElement(({ value }: any) => (
    <BannerCardComponent banner={value} />
  ));

  const SortableList = SortableContainer(
    ({ items }: ISortableContainerProps) => {
      return (
        <ul className="banner-sorting-container">
          {items.map((banner: any, index: number) => (
            <SortableItem value={banner} key={index} index={index} />
          ))}
        </ul>
      );
    }
  );

  return (
    <SortableList
      axis="x"
      items={banners}
      onSortEnd={(indexes: any) => {
        onSortEnd(indexes, props);
      }}
    />
  );
};

export default BannerSortComponent;
